import { component } from 'picoapp';
import Swiper, { Navigation, Pagination } from 'swiper';
import Drawer from '../../../js/utils/drawer';

export default component(async (node, ctx) => {
  /**
   * Data + elements
   */
  const modelToggles = node.querySelectorAll(' .js-modelToggle');
  const productItems = node.querySelectorAll(' .js-productItem');
  const filterDrawer = node.querySelector(' .js-filterDrawer');
  const filterDrawerBtns = node.querySelectorAll('.js-filterDrawerBtn');
  const infoDrawers = node.querySelectorAll('.js-infoDrawer');
  const infoDrawerTriggers = node.querySelectorAll('.js-infoDrawerTrigger');
  const filterBarScroll = node.querySelector('.js-filterBarScroll');
  const filterBarStatic = node.querySelector('.js-filterBarStatic');
  const filters = node.querySelectorAll('.js-filter');
  const collectionItems = node.querySelectorAll('.js-collectionItem');
  const productListItems = node.querySelectorAll('.js-productListItem');
  const filterLists = node.querySelectorAll('.js-filterList');
  const clearFilterBtns = node.querySelectorAll('.js-clearFilterBtn');
  const resultCount = node.querySelector('.js-resultCount');
  const filterCounts = node.querySelectorAll('.js-filterCount');
  const filterDesktop = document.querySelector('.js-filterDesktop');
  const header = document.querySelector(".header");

  const sliderElement = node.querySelector('.collections__info-drawer .js-slider');
  const sliderPagination = node.querySelector('.collections__info-drawer .js-sliderPagination');
  const mediaSliderPrevBtn = node.querySelector('.collections__info-drawer .js-mediaSliderPrevBtn');
  const mediaSliderNextBtn = node.querySelector('.collections__info-drawer .js-mediaSliderNextBtn');
  const swiperWrapper = node.querySelector('.collections__info-drawer .swiper');

  const filterBarActiveClass = 'collections__filter-bar--active';
  const filterBarHeaderActiveClass = 'collections__filter-bar--header-active';
  const modelToggleActiveClass = 'collections__model-toggle--active';
  const productItemToggledClass = 'product-item--toggled';

  const strings = window.theme.strings.collection;

  let previousScrollPos = window.scrollY;
  let slider;

  /**
   * Functions
   */
  const initSlider = () => {
    const reset = () => {
      if (slider?.destroy) {
        slider.destroy();
      }

      slider = new Swiper(sliderElement, {
        modules: [Pagination, Navigation],
        effect: 'coverflow',
        pagination: {
          el: sliderPagination,
          type: 'bullets',
          bulletClass: 'image-slider__page-bullet',
          bulletActiveClass: 'image-slider__page-bullet--active',
        },
        navigation: {
          prevEl: mediaSliderPrevBtn,
          nextEl: mediaSliderNextBtn,
        },
        centeredSlides: true,
        slidesPerView: 'auto',
        speed: 1000,
        loop: true,
      });
    };

    reset();
  };

  const initSliderArrows = () => {
    if (document.querySelector('.swiper-initialized')) {
      swiperWrapper?.addEventListener('mouseover', function (el) {
        mediaSliderNextBtn.style.transform = 'translateX(0)';
        mediaSliderPrevBtn.style.transform = 'translateX(0)';
      });

      swiperWrapper?.addEventListener('mouseout', function (el) {
        mediaSliderNextBtn.style.transform = 'translateX(28px)';
        mediaSliderPrevBtn.style.transform = 'translateX(-28px)';
      });
    }
  };

  const initFilters = () => {
    const clearFilterList = () => {
      const filterValues = node.querySelectorAll('.js-filterValueBtn');
      filterValues.forEach((value) => value.remove());
    };

    const filterCollectionItems = (titles) => {
      if (titles.length) {
        collectionItems.forEach((item) => {
          const { title } = JSON.parse(item.dataset.properties);
          const products = item.querySelectorAll('.js-productItem');

          if (titles.includes(title)) {
            item.hidden = false;

            products.forEach((product) => {
              product.hidden = false;
            });
          } else {
            item.hidden = true;

            products.forEach((product) => {
              product.hidden = true;
            });
          }
        });

        titles.forEach((title) => {
          filterLists.forEach((filterList) => {
            const button = document.createElement('button');
            filterList.appendChild(button);

            button.outerHTML = `<button type="button" class="collections__filter-value js-filterValueBtn" data-target="collection" data-property="title" data-value="${title}">
              <span>${title}</span>
              ${window.theme.templates.icons.closeSmall}
            </button>`;
          });
        });
      } else {
        collectionItems.forEach((item) => {
          item.hidden = false;

          const products = item.querySelectorAll('.js-productItem');
          products.forEach((product) => {
            product.hidden = false;
          });
        });
      }
    };

    const filterProductItems = (properties) => {
      // Update filter counts
      filters.forEach((filter) => {
        const { property } = filter.dataset;
        const count = filter.querySelector('.js-filterItemCount');

        if (!count) return;

        if (properties[property]) {
          count.hidden = false;
          count.innerText = `(${properties[property].length})`;
        } else {
          count.hidden = true;
          count.innerText = `(${0})`;
        }
      });
      // Update products items visibility
      if (Object.keys(properties).length) {
        // Create buttons
        Object.keys(properties)
          .filter((key) => key !== 'title' && key !== 'available')
          .forEach((key) => {
            properties[key].forEach((value) => {
              filterLists.forEach((filterList) => {
                const button = document.createElement('button');
                filterList.appendChild(button);

                button.outerHTML = `<button type="button" class="collections__filter-value js-filterValueBtn" data-target="product" data-property="${key}" data-value="${value}">
                <span>${value}</span>
                ${window.theme.templates.icons.closeSmall}
              </button>`;
              });
            });
          });

        const optionKeys = [''];

        const filteredProducts = [...productListItems].filter((item) => {
          const itemPropertiesArray = JSON.parse(item.dataset.properties);
          const itemPropertiesCombined = Object.assign({}, ...itemPropertiesArray);
          const allMatches = Object.keys(properties).every((key) => {
            let newKey = key;
            if (key === 'product_type') newKey = 'type';
            else if (key === 'brand') newKey = 'vendor';
            else if (key === 'shirt_type') newKey = 'model';
            let requiredValues = properties[key];
            if (requiredValues) {
              requiredValues = requiredValues.map((value) => value.toLowerCase());
            }
            let productValue = String(itemPropertiesCombined[newKey]);
            productValue = productValue.toLowerCase()
            if (newKey === 'size' && typeof productValue === 'string' || newKey === 'fit' && typeof productValue === 'string' || newKey === 'length' && typeof productValue === 'string') {
              productValue = productValue.split(',').map(s => s.trim());
            }
            if (!Array.isArray(productValue)) {
              productValue = [productValue];
            }
            const hasOverlap = productValue.some((pValue) => requiredValues.includes(pValue));
            return hasOverlap;
          });

          return allMatches;
        });

        // eslint-disable-next-line
        productListItems.forEach((product) => (product.hidden = true));

        if (!Object.keys(properties).includes('available')) {
          // eslint-disable-next-line
          filteredProducts.forEach((product) => (product.hidden = false));
        } else {
          // Exclude all but options when checking if in stock
          const getProductEntries = Object.entries(properties).filter(([key]) => {
            if (!optionKeys.includes(key)) return false;
            return true;
          });

          const getProductValues = getProductEntries.map((arr) => arr[1]);

          // Can't create a variant yet
          if (getProductValues.length <= 1) {
            // eslint-disable-next-line
            filteredProducts.forEach((product) => (product.hidden = false));
            return;
          }

          // Setup all possible variant combinations based on filters (only works for 2 options)
          const permutateArrays = (a, b) => a.flatMap((c) => b.map((d) => [c, d].flat()));
          const connect = (array) => array.join(' / ');
          const possibleVariants = getProductValues.reduce(permutateArrays).map(connect);

          const checkAvailableProducts = filteredProducts.filter((product) => {
            const { title, color, variants } = JSON.parse(product.dataset.properties);
            // console.log('🚀 ~ title:', title, color);

            if (Object.keys(properties).some((key) => optionKeys.includes(key))) {
              const hasAvailableVariants = variants.filter((variant) => {
                if (!variant.available) return false;

                for (const possibleVariant of possibleVariants) {
                  const splittedPossibleVariants = possibleVariant.split(' / ');

                  let isAvailable = true;
                  for (const splittedPossibleVariant of splittedPossibleVariants) {
                    if (!variant.title.includes(splittedPossibleVariant)) {
                      isAvailable = false;
                    }
                  }

                  if (isAvailable) {
                    return true;
                  }
                }

                return false;
              });

              if (hasAvailableVariants.length) {
                return true;
              }

              return false;
            }

            return true;
          });

          // eslint-disable-next-line
          checkAvailableProducts.forEach((product) => (product.hidden = false));
        }
      } else {
        productListItems.forEach((item) => {
          item.hidden = false;
        });
      }
    };

    const initFilterValueBtns = () => {
      const btns = node.querySelectorAll('.js-filterValueBtn');

      btns.forEach((btn) => {
        const { target, property, value } = btn.dataset;
        const filter = Array.from(filters).find((filter) => filter.dataset.target === target && filter.dataset.property === property); // eslint-disable-line

        const matchingInput = Array.from(filter.querySelectorAll('.js-input')).find((input) => input.dataset.value === value);

        btn.addEventListener('click', () => {
          matchingInput.checked = false;
          matchingInput.dispatchEvent(new Event('change'));
        });
      });
    };

    const toggleFilterList = () => {
      filterLists.forEach((filterList) => {
        const filterValueBtns = filterList.querySelectorAll('.js-filterValueBtn');

        if (filterValueBtns.length) {
          filterList.hidden = false;
        } else {
          filterList.hidden = true;
        }
      });
    };

    const updateInfo = () => {
      const visibleProductItems = Array.from(productListItems).filter((item) => item.offsetParent !== null); // eslint-disable-line

      resultCount.textContent = strings.viewResults.replace('%count%', visibleProductItems.length);
    };

    const getFilterProperties = () => {
      const collectionTitles = [];
      const productProperties = {};

      // Collect values
      filters.forEach((filter) => {
        const { target } = filter.dataset;
        const activeInputs = Array.from(filter.querySelectorAll('.js-input')).filter((input) => input.checked); // eslint-disable-line

        if (target === 'collection') {
          const titles = activeInputs.map((input) => input.dataset.value);

          if (titles.length) {
            collectionTitles.push(...titles);
          }
        } else if (target === 'product') {
          const { property } = filter.dataset;
          const values = activeInputs.map((input) => input.dataset.value);

          if (values.length) {
            productProperties[property] = values;
          }
        }
      });

      return { collectionTitles, productProperties };
    };

    const updateURLParams = () => {
      const { collectionTitles, productProperties } = getFilterProperties();
      const dataset = {
        ...productProperties,
      };

      if (collectionTitles.length) {
        dataset.title = collectionTitles;
      }

      const params = new URLSearchParams();

      Object.entries(dataset).forEach(([key, value]) => {
        params.set(key, value);
      });

      window.history.replaceState({}, '', `${window.location.pathname}${Object.keys(dataset).length ? `?${params.toString()}` : ''}`);
    };

    const readURLParams = () => {
      const params = new URLSearchParams(window.location.search);

      return Object.fromEntries(params);
    };

    const updateFilterStates = () => {
      const params = readURLParams();

      Object.values(params).forEach((values) => {
        values.split(',').forEach((value) => {
          const input = document.querySelector(`.js-input[data-value="${value}"]`);

          if (input) {
            input.checked = true;
          }
        });
      });
    };

    const updateValidFilterItems = () => {
      collectionItems.forEach((item) => {
        const listItems = item.querySelectorAll('.js-productListItem');
        const allHidden = Array.from(listItems).every((listItem) => listItem.hidden);

        if (allHidden) {
          item.hidden = true;
        }
      });

      filters.forEach((filter) => {
        if (filter.dataset.property === 'available') return;

        const listItems = filter.querySelectorAll('li');
        const allHidden = Array.from(listItems).every((listItem) => listItem.hidden);

        if (allHidden) {
          filter.hidden = true;
        } else {
          filter.hidden = false;
        }
      });
    };

    const runFilter = () => {
      const { collectionTitles, productProperties } = getFilterProperties();

      const totalCount = collectionTitles.length + Object.values(productProperties).length;
      filterCounts.forEach((filterCount) => {
        filterCount.innerText = `(${totalCount})`;

        if (totalCount > 0) {
          filterCount.hidden = false;
        } else {
          filterCount.hidden = true;
        }
      });

      const dataset = {
        ...productProperties,
      };

      if (collectionTitles.length) {
        dataset.title = collectionTitles;
      }

      clearFilterList();
      filterCollectionItems(collectionTitles);
      filterProductItems(dataset);
      updateValidFilterItems();
      initFilterValueBtns();
      toggleFilterList();
      updateInfo();
    };

    if (Object.values(readURLParams()).length) {
      updateFilterStates();
      runFilter();
    } else {
      runFilter();
      updateURLParams();
    }

    const clearFilter = () => {
      filters.forEach((filter) => {
        const inputs = filter.querySelectorAll('.js-input');

        inputs.forEach((input) => {
          // Skip 'availability' filter, must not be reset
          if (input.id === 'availability') return;

          input.checked = false;
        });
      });

      runFilter();
      updateURLParams();
    };

    filters.forEach((filter) => {
      const inputs = filter.querySelectorAll('.js-input');

      inputs.forEach((input) => {
        input.addEventListener('change', () => {
          runFilter();
          updateURLParams();
        });
      });
    });

    clearFilterBtns.forEach((btn) => {
      btn.addEventListener('click', clearFilter);
    });
  };

  const handleScroll = () => {
    let scrollingUp = false;
    const currentScrollPos = window.scrollY;
    const isDesktop = window.innerWidth >= 1024;

    if (currentScrollPos < previousScrollPos) {
      scrollingUp = true;
    }

    previousScrollPos = currentScrollPos;

    const scrolledPastFilterBarStatic = filterBarStatic.getBoundingClientRect().bottom < 0;

    if (scrolledPastFilterBarStatic) {
      filterBarScroll.classList.add(filterBarActiveClass);
      filterBarScroll.classList.add(filterBarHeaderActiveClass);
    } else {
      filterBarScroll.classList.remove(filterBarActiveClass);
      filterBarScroll.classList.remove(filterBarHeaderActiveClass);
    }

    if (scrollingUp && scrolledPastFilterBarStatic) {
      filterBarScroll.classList.add(filterBarHeaderActiveClass);
    }


    if (header && filterDesktop) {
      const headerHeight = header.offsetHeight;
      const filterBarTop = filterDesktop.getBoundingClientRect().top;

      if (filterBarTop <= headerHeight && isDesktop) {
        filterDesktop.classList.add("sticky-filter");
      } else {
        filterDesktop.classList.remove("sticky-filter");
      }
    }
  };

  const initModelToggle = () => {
    const toggleShowModel = () => {
      modelToggles.forEach((toggle) => {
        toggle.classList.toggle(modelToggleActiveClass);
      });

      productItems.forEach((item) => {
        let swiper = item.querySelector('.swiper') ? item.querySelector('.swiper').swiper : null;
        if (!swiper) return;
        if (modelToggles && typeof modelToggles == 'object' && modelToggles[0].classList.contains(modelToggleActiveClass)) {
          swiper.slideTo(1);
        } else {
          swiper.slideTo(0);
        }
      });
    };

    modelToggles.forEach((toggle) => {
      toggle.addEventListener('click', () => toggleShowModel());
    });
  };

  const initFilterDrawer = () => {
    const closeBtns = filterDrawer.querySelectorAll('.js-closeBtn');
    const drawer = Drawer(filterDrawer);

    filterDrawerBtns.forEach((btn) => {
      btn.addEventListener('click', () => drawer.open());
    });

    closeBtns.forEach((btn) => {
      btn.addEventListener('click', () => drawer.close());
    });
  };

  const initInfoDrawers = () => {
    infoDrawers.forEach((infoDrawer) => {
      const drawer = Drawer(infoDrawer);

      const closeBtn = infoDrawer.querySelector('.js-closeBtn');
      closeBtn.addEventListener('click', () => drawer.close());

      infoDrawerTriggers.forEach(function (infoDrawerTrigger) {
        infoDrawerTrigger.addEventListener('click', function () {
          const currIndex = this.getAttribute('data-index');
          const currId = this.getAttribute('data-id');

          slider.slideTo(currIndex);

          document.querySelectorAll(`.drawer__info [block-index]`).forEach((el) => {
            el.setAttribute('hidden', '');
          });

          document.querySelectorAll(`[block-index="${currIndex}"]`).forEach((el) => {
            el.removeAttribute('hidden');
            if (el.classList.contains('fabric_description')) {
              el.removeAttribute('hidden');
            }
          });

          document.querySelectorAll(`[block-id="${currId}"]`).forEach((el) => {
            if (el.classList.contains('collections__info-drawer__fabric-item')) {
              el.classList.add('font-semibold');
            }
          });

          drawer.open();
        });
      });
      // closeBtn.addEventListener('click', () => drawer.close());
    });
  };

  const destroyInfoDrawers = () => {
    var observer = new MutationObserver(function (mutations) {
      // wait until drawer closes
      setTimeout(() => {
        mutations.forEach(function (mutation) {
          if (!mutation.target.classList.contains('overlay--active')) {
            document.querySelectorAll('.drawer__header p').forEach(function (el) {
              el.setAttribute('hidden', '');
            });
            document.querySelectorAll('p.fabric_description').forEach(function (el) {
              el.setAttribute('hidden', '');
            });
            document.querySelectorAll('.collections__info-drawer__fabric-item').forEach(function (el) {
              el.classList.remove('font-semibold');
            });
          }
        });
      }, 1000);
    });

    observer.observe(document.querySelector('.overlay'), {
      attributes: true,
      attributeFilter: ['class'],
    });
  };

  const init = () => {
    initFilters();
    initModelToggle();
    initFilterDrawer();
    initInfoDrawers();
    handleScroll();
    initSlider();
    initSliderArrows();
    destroyInfoDrawers();

    ctx.on('window:scroll', handleScroll);
  };

  /**
   * Init
   */
  init();
});
